module.exports = __webpack_public_path__ + "static/img/logo-new.20bcbb4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo-new.png
// module id = aR72
// module chunks = 1